/**
 * @file PlanDetailHero.js
 * @description Wide hero image at the top of the plan-details page.
 */

import styles from './PlanDetailHero.module.scss';

export default function PlanDetailHero({ plan }) {
    const imageSrc = plan?.imageUrl ?? null;
    if (!imageSrc) return null;

    return (
        <div className={`ratio rounded-3 overflow-hidden ${styles.wrap}`}>
            <img
                src={imageSrc}
                alt=""
                className="w-100 h-100 object-fit-cover"
            />
        </div>
    );
}
